/** A labelled block in a Foundry form that holds more than one control (a list of chips, a project card): not a <label>, so a press on a chip never lands on the wrong control. */

import type { ReactNode } from 'react';

export function Block({ label, hint, children }: { label: ReactNode; hint?: ReactNode; children: ReactNode }) {
  return (
    <div role="group" className="grid min-w-0 content-start gap-1.5">
      <span className="text-xs font-medium text-foreground">{label}</span>
      {children}
      {hint ? <span className="text-xs text-muted">{hint}</span> : null}
    </div>
  );
}
